import { render, staticRenderFns } from "./SimpleModal.vue?vue&type=template&id=d4ae5f4a&scoped=true&"
import script from "./SimpleModal.vue?vue&type=script&lang=js&"
export * from "./SimpleModal.vue?vue&type=script&lang=js&"
import style0 from "./SimpleModal.vue?vue&type=style&index=0&id=d4ae5f4a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ae5f4a",
  null
  
)

export default component.exports